import { List, Map } from 'immutable';
//import shortid from 'shortid';

/* * * * * * * * * MapApp Reducer * * * * * * * * */
let initialState = Map({
  "foundProperty":null,
  "drawnPolygons": List(),
  "overlays": List(),
  "errorMessage": null,
  "mapCenter": [20.808, -156.329],
  "mapZoom":11,
  "mapBounds": null,
  "draggable":true
});

const MapApp = (state = initialState, action) => {

  switch(action.type){

    case "VIEWPOINT_CHANGE":
      return state.set('mapCenter',action.viewpoint.center).set('mapZoom',action.viewpoint.zoom)

    /* * * * * * * * * ACTION RECEIVE DATA * * * * * * * * */
    case "ERROR":
      return state.set('errorMessage', action.message);

    case "CLEAR_ERROR_MESSAGE":
      return state.set('errorMessage', null);

    case "RECEIVE_DATA":
      return state.set('errorMessage', null)

    case "RECENTER_MAP":
      return state.set("mapCenter", [20.808, -156.329]).set("mapZoom", 11)

    case "SET_MAP_BOUNDS":
      return state.set("mapBounds", action.bounds)

    case "FIND_PROPERTY":
      return state.set('foundProperty', action.property)

    case "LOSE_PROPERTY":
      return state.set('foundProperty', null)

    /* * * * * * * * * LEAFLET OVERLAYS STUFF * * * * * * * * */
    case "RECEIVE_OVERLAYS":
      return state.set('overlays', List(action.data));

    default:
      return state;
  }
}

export default MapApp;



// WEBPACK FOOTER //
// ./src/reducers/map.js